module.exports = "https://cwa.roocdn.com/_next/static/mgm.e00ac2d5.svg";